<template>
  <div :id="this.$route.name">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">لیست حقوق</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row"></div>
        <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="Column" :excel="true" :propsRows="rows"
          :action="true" :hasRowNum="true" :Sortable="true">
          <template slot="action-slot" slot-scope="props">
            <b-dropdown size="md" variant="link" class="d-inline text-center" toggle-class="text-decoration-none "
              title="سایر عملیات ها" no-caret>
              <template #button-content>
                <h5><i class="fad fa-poll-people"></i></h5>
              </template>
              <b-dropdown-item href="#" @click="GetInsuranceDiskette(props.props)" class="text-center">دیسکت
                بیمه</b-dropdown-item>
              <b-dropdown-item href="#" @click="GettaxDiskette(props.props)" class="text-center">دیسکت
                مالیات</b-dropdown-item>
              <b-dropdown-item href="#" @click="GetFishSalaryList(props.props)" class="text-center">چاپ فیش
                حقوقی</b-dropdown-item>
              <b-dropdown-item href="#" @click="GetSalaryListStimul(props.props)" class="text-center"> چاپ لیست حقوق
              </b-dropdown-item>
              <!-- <b-dropdown-item href="#" @click="GetSalaryList(props.props)" class="text-center">چاپ لیست حقوق</b-dropdown-item> -->
              <!-- <b-dropdown-item href="#" class="text-center">چاپ خلاصه لیست</b-dropdown-item> -->
              <!-- <b-dropdown-item href="#" @click="GetInsuranceList(props.props)" class="text-center">چاپ لیست بیمه</b-dropdown-item> -->
              <b-dropdown-item href="#" @click="GetInsuranceListStimul(props.props)" class="text-center">چاپ لیست بیمه
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="SabtSand(props.props)" class="text-center">ثبت سند موقت</b-dropdown-item>
              <b-dropdown-item href="#" @click="EditInsuranceList(props.props)"
                class="text-center">ویرایش</b-dropdown-item>
              <b-dropdown-item href="#" @click="DeleteInsuranceList(props.props)"
                class="text-center">حذف</b-dropdown-item>
            </b-dropdown>
          </template>
        </BnpGrid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      rows: [],
      Column: [
        {
          name: 'Id',
          label: 'Id',
          visibility: false,
        },
        {
          name: 'WorkShopName',
          label: 'کارگاه',
          visibility: true,
        },
        {
          name: 'Year',
          label: 'سال',
          visibility: true,
        },
        {
          name: 'Month',
          label: 'ماه',
          visibility: true,
        },
        {
          name: 'PersonelCount',
          label: 'تعداد پرسنل',
          visibility: true,
        },
        {
          name: 'TotalPayment',
          label: 'پرداختی',
          visibility: true,
        },
        {
          name: 'DeductionsSum',
          label: 'کسورات',
          visibility: true,
        },
        {
          name: 'NetPayment',
          label: 'خاص پرداختی',
          visibility: true,
        },
        {
          name: 'FisheBime',
          label: 'مبلغ فیش بیمه',
          visibility: true,
        },
      ],
    }
  },
  components: { Card, BnpGrid },
  mounted() {
    this.GetData()
  },
  methods: {
    GetData() {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'Salary',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois)
        .then((data) => {
          if (data != null) {
            if (data.IsSuccess == true) {
              // console.log(data);
              for (let index = 0; index < data.Data.length; index++) {
                const element = data.Data[index]
                this.rows.push(element)
              }
            }
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetInsuranceDiskette(data) {
      this.$router.push({ name: 'InsuranceDiskette', query: { SalaryId: data.Id } })
    },
    GettaxDiskette(data) {
      this.$router.push({ name: 'TaxDiskette', query: { SalaryId: data.Id } })
    },
    GetFishSalaryList(data) {
      this.$router.push({ name: 'FishSalaryList', query: { SalaryId: data.Id } })
    },
    GetSalaryList(data) {
      this.$router.push({ name: 'PrintSalaryList', query: { SalaryId: data.Id } })
    },
    GetInsuranceList(data) {
      this.$router.push({ name: 'PrintInsuranceList', query: { SalaryId: data.Id } })
    },
    GetInsuranceListStimul(data) {
      var LogoAddress = this.$cookies.get('URL') + this.$session.get('CompanyLogo')
      var DataAxios = { Method: 'POST', Action: 'ReportBuilder/InsuranceList', ArryfildValue: { Id: data.id, Address: LogoAddress } }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'succes') {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.target = '_blank'
          var url = this.$cookies.get('URL') + result.link
          console.log(result.link.split('\\')[1])
          a.href = url
          a.download = result.link.split('\\')[1]
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    SabtSand(data) {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadSalary/' + data.Id,
      }
      this.$PostData(DataAxois)
        .then((data) => {
          if (data.IsSuccess == true) {
            this.$mySweetDefaultTost('', data.Message, 'success', 3000)
          } else {
            this.$mySweetDefaultTost('', data.Message, 'error', 3000)
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    DeleteInsuranceList(data) {
      this.$RemoveAlert('اطمینان دارید از حذف ' + '؟').then((res) => {
        if (res) {
          var DataAxois = {
            ArryfildValue: {},
            Method: 'Delete',
            Action: 'Salary/' + data.Id,
            Token: this.$session.get('Token'),
          }
          this.$PostData(DataAxois)
            .then((data) => {
              if (data.IsSuccess == true) {
                this.$mySweetDefaultTost('', data.Message, 'success', 3000)
                this.rows = []
                this.GetData()
              } else {
                this.$mySweetDefaultTost('', data.Message, 'error', 3000)
              }
            })
            .finally(() => {
              this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
              })
            })
        }
      })
    },
    EditInsuranceList(data) {
      this.$router.push({ name: 'Salary', params: { Status: 'Edit', DataRow: data } })
    },
    GetSalaryListStimul(SalaryList) {
      var LogoAddress = this.$cookies.get('URL') + this.$session.get('CompanyLogo')
      var DataAxios = { Method: 'POST', Action: 'ReportBuilder/SalaryLIstStimulPrint', ArryfildValue: { Id: SalaryList.id, Address: LogoAddress } }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'succes') {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.target = '_blank'
          var url = this.$cookies.get('URL') + result.link
          console.log(result.link.split('\\')[1])
          a.href = url
          a.download = result.link.split('\\')[1]
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
  },
}
</script>
<style scoped></style>
